var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9H12.25M4.25 5H8.25M6.25 5V16C6.25 16.2652 6.35536 16.5196 6.54289 16.7071C6.73043 16.8946 6.98478 17 7.25 17H12.25M12.25 8C12.25 7.73478 12.3554 7.48043 12.5429 7.29289C12.7304 7.10536 12.9848 7 13.25 7H19.25C19.5152 7 19.7696 7.10536 19.9571 7.29289C20.1446 7.48043 20.25 7.73478 20.25 8V10C20.25 10.2652 20.1446 10.5196 19.9571 10.7071C19.7696 10.8946 19.5152 11 19.25 11H13.25C12.9848 11 12.7304 10.8946 12.5429 10.7071C12.3554 10.5196 12.25 10.2652 12.25 10V8ZM12.25 16C12.25 15.7348 12.3554 15.4804 12.5429 15.2929C12.7304 15.1054 12.9848 15 13.25 15H19.25C19.5152 15 19.7696 15.1054 19.9571 15.2929C20.1446 15.4804 20.25 15.7348 20.25 16V18C20.25 18.2652 20.1446 18.5196 19.9571 18.7071C19.7696 18.8946 19.5152 19 19.25 19H13.25C12.9848 19 12.7304 18.8946 12.5429 18.7071C12.3554 18.5196 12.25 18.2652 12.25 18V16Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSub);
export default __webpack_public_path__ + "static/media/Sub.a8ddfc8fe6cdbbf4fc13cbc48e23c25a.svg";
export { ForwardRef as ReactComponent };